<p><strong>Załącznik nr 1</strong><br></p>
<p><strong>Rabaty na fakturze</strong><strong>&nbsp;</strong></p>
<p>
  L&rsquo;Or&eacute;al udzieli Klientowi rabat&oacute;w na fakturze od cen
  katalogowych netto w wysokości i na warunkach określonych poniżej:
</p>
<ol>
  <li>
    Rabat przyznawany będzie Klientowi w systemie kwartalnym w oparciu o
    obowiązującą &bdquo;Tabelę warunk&oacute;w handlowych&rdquo;.
  </li>
  <li>
    Realizacja warunk&oacute;w zawartych w &bdquo;Tabeli warunk&oacute;w
    handlowych&rdquo; w danym kwartale determinuje wysokość rabatu
    strukturalnego Klienta w następnym kwartale kalendarzowym. Przez
    &bdquo;kwartał&rdquo; rozumiany jest pełny kalendarzowy kwartał
    wsp&oacute;łpracy z marką L&rsquo;Or&eacute;al Professionnel.
  </li>
  <li>
    Rabat wypracowany w danym kwartale zgodnie z powyższą zasadą zostanie
    naliczony od 10 dnia pierwszego miesiąca następnego kwartału kalendarzowego.
  </li>
  <li>
    Wysokość rabat&oacute;w strukturalnych obowiązujących w roku 2021
    determinuje poniższa &bdquo;Tabela warunk&oacute;w handlowych&rdquo;:<br />
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td width="66">
            RABAT
          </td>
          <td width="653">
            WARUNKI
          </td>
        </tr>

        <tr>
          <td width="66">
            40%
          </td>
          <td width="653">
            Za świadczenie usług fryzjerskich konsumentom
          </td>
        </tr>
        <tr>
          <td width="66">
            2%
          </td>
          <td width="653">

              Za złożenie zam&oacute;wień minimum w dw&oacute;ch miesiącach w
              kwartale

          </td>
        </tr>
        <tr>
          <td width="66">
            2%
          </td>
          <td width="653">
            Za zamówienie przez platformę B2B  raz w kwartale 

          </td>
        </tr>
        <tr>
          <td width="66">
            2%
          </td>
          <td width="653">

              Za pozytywną ewolucję zakupu koloryzacji vs analogiczny kwartał
              poprzedniego roku lub za zakup powyżej 150 sztuk koloryzacji w
              kwartale

          </td>
        </tr>
        <tr *ngIf="data.type !== 'partner'">
          <td width="66">
            1%
          </td>
          <td width="653">
            Za członkostwo w programie Salon Expert
          </td>
        </tr>
      </tbody>
    </table>
  </li>
  <li>Wartość maksymalna rabatu na fakturze wynosi {{ data.type === 'partner' ? '46' : '47' }}%.</li>
  <li>
    Powyższe warunki nie dotyczą produkt&oacute;w Steampod i Instant Highlights
    oraz Sweet Meches.
  </li>
  <li>
    L&rsquo;Or&eacute;al zastrzega sobie prawo do wykluczenia z powyższych
    warunk&oacute;w innych gam i produkt&oacute;w. O tym, że inne gamy bądź
    produkty zostaną wykluczone, L&rsquo;Or&eacute;al poinformuje za
    pośrednictwem poczty elektronicznej z 60-dniowym wyprzedzeniem.
  </li>
</ol>
